import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import Api from '../Api'
import moment from 'moment'

export const types = {
    FETCH: 'SETTINGS/FETCH',
    LOAD: 'SETTINGS/LOAD',
    SET: 'SETTINGS/SET',    
}

export const actions = {
    fetch: () => ({ type: types.FETCH }),
    load: (settings) => ({ type: types.LOAD, settings }),
    set: (name, value) => ({ type: types.SET, name, value }),    
}

export const initialState = {
}

const settingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.LOAD:
            return {
                ...state,
                ...action.settings,
                update_time: moment(action.settings.update_time),
            };
        case types.SET:            
            return {
                ...state,
                [action.name]: action.value                
            };        
        default:
            return state;
    }
}
export default settingsReducer;

export function* fetch(action) {
    const settings = yield call(Api.fetchSettings);
    yield put(actions.load(settings));
}

export function* set(action) {    
    yield call(Api.setSettings, { [action.name]: action.value });
}

export function* settingsFlow() {
    yield takeLatest(types.FETCH, fetch);
    yield takeEvery(types.SET, set);
}
